import { Trans, useTranslation } from "react-i18next";

import DropdownWithSearch from "features/ui/DropdownWithSearch/DropdownWithSearch";
import { FilterOperator, FilterType } from "features/ui/Filters/types";
import { getOperatorsSelectOptions } from "features/ui/Filters/utils";
import { SelectOption } from "features/ui/Select";

interface Props {
  type: FilterType;
  selected: SelectOption<FilterOperator>;
  onChange: (selected: SelectOption<FilterOperator>) => void;
  disableSelectFilters?: boolean;
  disableContainsFilters?: boolean;
  disableIsEmptyFilters?: boolean;
  disableStartsWithFilters?: boolean;
  disableIsNotFilteredFilters?: boolean;
  whitelistedFilterOperators?: FilterOperator[];
  fullWidth?: boolean;
  className?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  isInsideFilterBuilder?: boolean;
}

const OperatorsDropdown = ({
  type,
  selected,
  onChange,
  disableSelectFilters = false,
  disableContainsFilters = false,
  disableIsEmptyFilters = false,
  disableStartsWithFilters = false,
  disableIsNotFilteredFilters = false,
  whitelistedFilterOperators,
  className,
  disabled,
  autoFocus,
  fullWidth,
  isInsideFilterBuilder = false,
}: Props) => {
  const { t } = useTranslation("filters");
  const data = getOperatorsSelectOptions(t, {
    type,
    disableSelectFilters,
    disableContainsFilters,
    disableIsEmptyFilters,
    disableStartsWithFilters,
    disableIsNotFilteredFilters,
    whitelistedFilterOperators,
  });

  const disabledModified = data.length < 2 || disabled;

  const isOccursFilter = [
    FilterOperator.OCCURS,
    FilterOperator.NOT_OCCURS,
  ].includes(selected.id);

  return (
    <div className="flex flex-row gap-4">
      <DropdownWithSearch
        autoFocus={autoFocus}
        openOnAutoFocus={autoFocus}
        options={[]}
        groupedOptions={data}
        selectedOption={selected}
        onSelectedOptionChange={onChange}
        disabled={disabledModified}
        testId="operators-dropdown-wrap"
        className={className}
        disableClearable
        autoWidth={!fullWidth}
        fullWidth={fullWidth}
        popperClassName={isInsideFilterBuilder ? "filterBuilder" : ""}
      />
      {isOccursFilter && (
        <div className="text-sm leading-7 flex-1 truncate">
          <Trans
            t={t}
            i18nKey="exists_all_of_following_true"
            components={{ bold: <b /> }}
          />
        </div>
      )}
    </div>
  );
};
export default OperatorsDropdown;
